import { Injectable } from '@angular/core';
import { Observable, Observer, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  private showObserver: Observer<boolean>;
  public showObservable: Observable<boolean>;

  private enableObserver: Observer<boolean>;
  public enableObservable: Observable<boolean>;

  private errorObserver: Observer<any>;
  private subject = new Subject<any>();
  public errorObservable = this.subject.asObservable();

  constructor() { }

  public notifyMessage(mes: any): void  {
    this.subject.next(mes);
  }

  public hide = () => this.errorObserver.next(false);

  public show = () => this.errorObserver.next(false);

  public enable = () => this.enableObserver.next(false);

  private disable = () => this.enableObserver.next(true);



}

